"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
/**
 * Style dependencies
 */
require("swiper/css");
require("swiper/css/autoplay");
require("swiper/css/navigation");
require("swiper/css/pagination");
exports.default = () => {
    const el = document.querySelector('.MinimalCarousel .swiper');
    if (el) {
        const swiper = new swiper_1.default('.MinimalCarousel .swiper', {
            modules: [modules_1.Autoplay],
            autoplay: {
                delay: 7000,
            },
            speed: 1000,
            loop: true,
        });
    }
};
